import React from 'react'
import Signup from '../Components/Signup/Signup'

function SignupPage() {
  return (
    <div >
        <Signup></Signup>
    </div>
  )
}
export default SignupPage
